import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {LocalStorageService} from "../../_services/local-storage.service";
import {Title} from "@angular/platform-browser";
import {Community} from "../../_types/communities";
import {ActivatedRoute} from "@angular/router";
import {CommunitiesService} from "../../_services/communities.service";

@Component({
    selector: 'app-community-dynamic-page',
    templateUrl: './community-dynamic-page.component.html',
    styleUrl: './community-dynamic-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommunityDynamicPageComponent {
    content: any;
    title: string = 'Info'
    private readonly localStorageService: LocalStorageService = inject(LocalStorageService);

    constructor(private route: ActivatedRoute,
                private communitiesService: CommunitiesService,
                private titleService: Title) {
        this.route.params
            .subscribe(params => {
                let community: Community | null = this.lastSelectedCommunity
                if (community?.id && params['id']) {
                    this.communitiesService.getCommunityPages(community?.id).subscribe(r => {
                        for (let page of r) {
                            if (page.id == params['id']) {
                                this.title = page.title
                                this.titleService.setTitle(page.title);
                                this.content = page.content_text_rendered || page.content || '';
                            }
                        }
                    })
                }
            });
    }

    get lastSelectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }
}
